import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { useRef } from "react";
import * as THREE from "three";
import { TextureLoader } from "three";
import img from "../assets/textures/continents_mask.png"

function NeonEarth() {
  const groupRef = useRef();

  // PNG trasparente con soli continenti
  const continents = useLoader(
    TextureLoader,
    img
  );

  // migliora qualità: evita “sgranature”
  continents.colorSpace = THREE.SRGBColorSpace;
  continents.anisotropy = 8;
  continents.wrapS = THREE.RepeatWrapping;
  continents.wrapT = THREE.ClampToEdgeWrapping;

  // "de-zoom": aumenta repeat.x (>1 = continenti più piccoli)
  continents.repeat.set(1, 1);   // prova 1.05 / 1.10 / 1.15
  continents.center.set(0.5, 0.5);

  // ricentra dopo repeat (aggiusta a occhio)
  continents.offset.set(-0, 0);    // prova -0.02 / -0.08
  continents.needsUpdate = true;

  useFrame(() => {
    if (groupRef.current) groupRef.current.rotation.y += 0.0012;
  });

  return (
    <group ref={groupRef}>
      {/* Corpo semi-trasparente */}
      <mesh>
        <sphereGeometry args={[2.5, 96, 96]} />
        <meshPhysicalMaterial
          color="#14a7ad"
          transparent
          opacity={1}
          roughness={0.2}
          metalness={0.2}
          clearcoat={0.7}
          transmission={.6}
          thickness={1}
        />
      </mesh>

      {/* Wireframe neon */}
      {/* <mesh>
        <sphereGeometry args={[2.50, 96, 96]} />
        <meshBasicMaterial
          color="#14a7ad"
          wireframe
          transparent
          opacity={0.1}
        />
      </mesh> */}
      <mesh>
        <icosahedronGeometry args={[2.52, 30]} />
        <meshBasicMaterial
          color="#fff"
          wireframe
          transparent
          opacity={.1}
        />
      </mesh>

      {/* Continenti neon (overlay) */}
      <mesh>
        <sphereGeometry args={[2.5, 96, 96]} />
        <meshBasicMaterial
          map={continents}
          transparent
          opacity={0.9}
          color="#14a7ad"
          blending={THREE.AdditiveBlending}
          depthWrite={false}
        />
      </mesh>
    </group>
  );
}

export default function MinimalGlobe() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Canvas camera={{ position: [0, 0, 6], fov: 50 }} gl={{ alpha: true }}>
        <ambientLight intensity={.5} />
        <pointLight position={[3, 1, -1]} intensity={1.2} color="#1cc7ff" />
        <pointLight position={[-2, -1, -2]} intensity={0.6} color="#0b5cff" />
        <NeonEarth />
      </Canvas>
    </div>
  );
}